/**
 * useQuotas — Phase 15
 *
 * Loads the paywall snapshot once per mount. Returns { data, loading, refetch }.
 * The refetch function is exposed so pages can bump the counter after a
 * successful action (e.g. right after a translation).
 */
import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useQuotas() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    const load = useCallback(async () => {
        try {
            const { data } = await api.get("/access/quotas");
            setData(data);
        } catch (err) {
            // Not fatal — the UI will just render without counters. Log for
            // triage.
            console.warn("[useQuotas] snapshot fetch failed:", err);
            setData(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        load();
    }, [load]);

    return { data, loading, refetch: load };
}
